import { openProfessorK } from "../utils/utilityEtc"
import  { useUserInfo } from '.'
import { useCallback } from "react";

export default function useProfessorK () {
  const { info } = useUserInfo();

  // 프로페서K 로 이동
  const handleProfessorKOpen = useCallback(() => {
    if (!info || !info.learnerCode) return;

    const {learnerCode} = info;
    openProfessorK(learnerCode)
  }, [info])

  return {handleProfessorKOpen}
}

